import { render, staticRenderFns } from "./ImpersonationBanner.vue?vue&type=template&id=052ab56f"
import script from "./ImpersonationBanner.vue?vue&type=script&lang=js"
export * from "./ImpersonationBanner.vue?vue&type=script&lang=js"
import style0 from "./ImpersonationBanner.vue?vue&type=style&index=0&id=052ab56f&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports